import * as React from "react";
import { Query, QueryResult } from "react-apollo";
import {
  OrderSumItemsQuery,
  OrderSumItemsQueryVariables,
  SumSteps
} from "../../__generated__/types";
import { ORDER_SUM_QUERY } from "./queries";

export class OrdersSumQuery extends Query<
  OrderSumItemsQuery,
  OrderSumItemsQueryVariables
> {}

interface Props {
  startTimeStamp: number;
  endTimeStamp: number;
  timeStep: SumSteps;

  children(
    props: QueryResult<OrderSumItemsQuery, OrderSumItemsQueryVariables>
  ): JSX.Element | null;
}

export default ({
  children,
  startTimeStamp,
  endTimeStamp,
  timeStep
}: Props) => {
  return (
    <OrdersSumQuery
      variables={{
        startEpoch: startTimeStamp,
        endEpoch: endTimeStamp,
        timeStep: timeStep
      }}
      query={ORDER_SUM_QUERY}
    >
      {result => children(result)}
    </OrdersSumQuery>
  );
};



// WEBPACK FOOTER //
// ./src/queries/OrdersSumQuery/OrdersSumQuery.tsx